import { render, staticRenderFns } from "./ActivityNotificationSettings.vue?vue&type=template&id=2ec2531b&"
import script from "./ActivityNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./ActivityNotificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports